import { cn } from '@nexelem/utils';
import { PropsWithChildren } from 'react';

type DrawerFooterProps = {
  className?: string;
};

export const DrawerFooter = ({ children, className }: PropsWithChildren<DrawerFooterProps>) => (
  <div
    className={cn(
      'box-border flex h-15 shrink-0 items-center justify-end gap-3 border-t border-border-primary px-6',
      className,
    )}
  >
    {children}
  </div>
);
